<template>
    <div id="appraise-details" v-loading="loading">
        <div class="title">审核管理 > 亲子票务管理 > <span class="title-detail" @click="$router.go(-1)"> 评价列表</span></div>
        <div class="main">
            <div class="user-left">
                <ul>
                    <li>
                        用户名称： <span>{{ data.user_name }}</span>
                    </li>
                    <li>
                        景区名称： <span>{{ data.spu_name }}</span>
                    </li>
                    <li>
                        门票名称： <span>{{ data.sku_name }}</span>
                    </li>
                    <li>
                        检票时间： <span>{{ data.time_used }}</span>
                    </li>
                    <li>
                        评价时间： <span>{{ data.created_at }}</span>
                    </li>
                </ul>
            </div>
            <div class="line"></div>
            <div class="appraise-right" v-if="data.content">
                <div class="subtitle" >
                    <h4>评价内容</h4>
                </div>
                <div class="rate">
                    <div class="rate-item" v-for="rate in data.score_list" :key="rate.id">
                        <span>{{ rate.name }}</span>
                        <el-rate
                            v-model="rate.score"
                            disabled
                            show-score
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                    </div>
                    <div class="tabs">
                        <el-tag v-for="item in tabList" :key="item">{{item}}</el-tag>
                    </div>
                </div>
                <div class="content">
                    {{ data.content }}
                </div>
                <div class="reply" v-if="!data.rep_content">
                    <!-- <el-input type="textarea" v-model="rep_content" ref="textRep" @blur="onBlur" v-if="replying"></el-input> -->
                    <mavon-editor @blur="onBlur" v-if="replying" placeholder="请输入评价内容" v-model="rep_content" ref="textRep"/>
                    <el-button type="primary"  class="reply-button" v-if="replying" :style="{ float: replying ? 'right': 'none' }" @click="onReplyEvaluation">回复评价</el-button>
                    <el-button type="primary" class="reply-button" v-else @click="changeRepState">回复评价</el-button>
                </div>
                <div class="subtitle" v-if="data.rep_content">
                    <h4>评价回复</h4>
                </div>
                <div class="content" v-if="data.rep_content">
                    <div v-html="mdValue"></div>
                </div>
                <p style="margin: 20px 0px;">注：遇到违规评论想要屏蔽请及时联系管理员</p>
                <el-button v-if="data.rep_content" type="primary" style="float: right;" @click="onReplyEvaluation">删除回复</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getEvaluationDetail, setEvaluationContent } from '@/api/baby/evaluation.js'
var MarkdownIt = require('markdown-it');
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
});
export default {
    data () {
        return {
            value: 3.7,
            replying: false,
            data: {},
            rep_content: '',
            loading: false,
        }
    },
    computed: {
        tabList () {
            let data = [];
            if (this.data.score_list) {
                for(let i = 0; i < this.data.score_list.length; i++) {
                    if (this.data.score_list[i].child.length) {
                        data.push(this.data.score_list[i].child)
                    }
                }
            }
            return data.flat(Infinity).map(item => { return item.name })
        },
        mdValue () {
            if (this.data.rep_content) {
                return md.render(this.data.rep_content);
            } else {
                return ''
            }
        }
    },
    methods: {
        // 回复/删除
        onReplyEvaluation () {
            let data = {
                id: this.data.id
            }
            if (this.rep_content) {
                data.content = this.rep_content;
                setEvaluationContent(data)
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('回复成功！');
                            this.initEvaluation();
                        } else {
                            this.$message.error(err.msg);
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.msg);
                    })
                    .finally(_=> {
                        this.replying = false;
                        this.rep_content = '';
                    })
            } else {
                data.content = 'delete';
                this.$confirm('删除该回复,是否继续？', '提示')
                    .then(res => {
                        setEvaluationContent(data)
                            .then(res => {
                                if (res.data.code == 0) {
                                    this.$message.success('已删除回复！');
                                    this.initEvaluation();
                                } else {
                                    this.$message.error(err.msg);
                                }
                            })
                            .catch(err => {
                                this.$message.error(err.msg);
                            })
                            .finally(_=> {
                                this.replying = false;
                                this.rep_content = '';
                            })
                    })
                    .catch(err => {

                        this.$message.info('已取消操作！')
                    })
            }
            // 请求结束后关闭输入框
        },
        // 失去焦点
        onBlur () {},
        // 点击回复评价进行回复
        changeRepState () {
            this.replying = true;
            this.$nextTick(() => {
                this.$refs.textRep.$el.focus();
            })
        },
        initEvaluation () {
            if (this.$route.query.id == 'undefined' || !this.$route.query.id) {
                return
            }
            let params = {
                id: this.$route.query.id
            }
            this.loading = true;
            getEvaluationDetail(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = {...res.data.data};
                        this.data.sku_name = this.$route.query.sku_name;
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        }
    },
    mounted () {
        this.initEvaluation()
    }
}
</script>

<style lang="scss" scoped>
    #appraise-details {
        height: 100%;
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            font-weight: 600;
            .title-detail {
                margin-left: 5px;
                color: rgb(109, 109, 109);
                cursor: pointer;
            }
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
        }
        .main {
            margin: 24px;
            border-radius: 0;
            background-color: #fff;
            display: flex;
            min-height: 100%;
            .user-left {
                padding: 48px 48px 0px 70px;
                li {
                    font-size: 18px;
                    margin-top: 24px;
                    width: 320px;
                    &::marker {
                        font-size: 30px;
                        color: #ccc;
                    }
                }
            }
            .line {
                min-width: 8px;
                background-color: #f0f2f5;
            }
            .appraise-right {
                padding: 72px;
                flex: 1;
                .rate {
                    .rate-item {
                        display: flex;
                        margin-top: 16px;
                        span {
                            font-size: 18px;
                            display: block;
                            width: 100px;
                        }
                        .el-rate {
                            margin-left: 16px;
                        }
                    }
                    .tabs {
                        margin-top: 12px;
                    }
                }
                .content {
                    margin-top: 24px;
                    margin-bottom: 24px;
                    font-size: 16px;
                    line-height: 30px;
                }
                .reply {
                    .reply-button {
                        margin-top: 12px;
                    }
                }
                .subtitle {
                    margin: 35px 0;
                    display: flex;
                    align-items: center;
                    &:first-child {
                        margin-top: 0;
                    }
                    h4 {
                        padding-left: 20px;
                        line-height: 18px;
                        position: relative;
                        font-size: 18px;
                        font-weight: bold;
                        color: #333333;
                        &::before {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 0;
                            height: 100%;
                            width: 4px;
                            background: #2448ff;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .reply {
        .el-textarea {
            .el-textarea__inner {
                min-height: 80px !important;
            }
        }
    }

    ::v-deep .tabs {
        .el-button {
            background-color: #f5f5f5;
            border-color: #f5f5f5;
            &:hover {
                color: #909399;
            }
            &:active {
                color: #909399;
            }
        }

        .el-tag {
            background-color: rgb(245, 245, 245);
            color: #808080;
            height: 40px;
            line-height: 40px;
            border: none;
            border-radius: 5px;
            margin-left: 12px;
            padding: 0 15px;
            cursor: pointer;
            &:hover {
                // color: #000;
                // font-size: 18px;
            }
            &:first-child {
                margin-left: 0px;
            }
        }
    }
</style>